import { ListingDetail } from '@/models/ListingDetail';
import Defs from './Defs';

export default class ListingUtil {

    public static getSqFootage(mainLivingArea: number | null) {
        if (mainLivingArea === null) {
            return Defs.LISTING_NO_VALUE_NUM;
        }
        return mainLivingArea;
    }

    public static getPriceShortened(price: number, isMulti: number) {
        let lPriceStr = Defs.LISTING_NO_VALUE;
        let lPrice = 0;
        if (price === null) {
            return Defs.LISTING_NO_VALUE;
        }
        if (price >= 1000 && price < 1000000) {
            lPrice = Math.round(price / 1000) * 1000;
            lPrice = lPrice / 1000;
            if (isMulti === 1) {
                lPriceStr = lPrice + 'K+';
            } else {
                lPriceStr = lPrice + 'K';
            }
        } else if (price >= 1000000) {
            lPrice = Math.round(price / 100000) * 100000;
            lPrice = lPrice / 1000000.0;
            if (isMulti === 1) {
                lPriceStr = lPrice + 'M+';
            } else {
                lPriceStr = lPrice + 'M';
            }
        } else {
            if (isMulti === 1) {
                lPriceStr = '<1K+';
            } else {
                lPriceStr = '<1K';
            }
        }
        return lPriceStr;
    }

    public static getListingPriceBasedOnStatus(status: string, soldPrice: any, price: any, listClass: any, isLoggedIn: boolean) {

        let lPrice = '';
        if (status === '2' && soldPrice !== null && soldPrice !== 0) {
            lPrice = ListingUtil.getFormatedPrice(soldPrice);
        } else {
            lPrice = ListingUtil.getFormatedPrice(price);
        }


        if (status !== '2' || (isLoggedIn && status === '2')) {
            lPrice = this.getStatusAsString(status, listClass) + ' | ' + lPrice;
        } else {
            lPrice = this.getStatusAsString(status, listClass);
        }

        return lPrice;
    }

    public static getStatusAsString(status: string | null | undefined, classCode: number) {

        if (status === null || status === undefined) {
            return 'UNKNOWN';
        }

        if ((status === '1' || status === '1_0') && classCode === 2) {
            return 'ACTIVE';
        } else if (status === '1' || status === '1_0') {
            return 'FOR SALE';
        } else if (status === '2' || status === '2_0') {
            return 'SOLD';
        } else if (status === '3' || status === '3_0') {
            return 'PENDING';
        } else if (status === '4' || status === '4_0') {
            return 'EXPIRED';
        } else if (status === '5' || status === '5_0') {
            return 'CANCELLED';
        } else if (status === '5_1') {
            return 'WITHDRAWN';
        } else if (status === '6' || status === '6_0') {
            return 'RENTED';
        }
        return 'UNKNOWN';
    }

    public static getDaysOnMarket(listDate: any, listStatus: any, firmDate: any) {

        let lDays = null;
        let lDaysOnMarket: string | number | null = '';
        try {
            if (listStatus === '2') {
                lDaysOnMarket = this.date_diff_indays(listDate, firmDate);
                lDays = lDaysOnMarket;
            } else {
                const now = new Date();
                // now.format('m/dd/yy');
                const nowStr = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
                lDaysOnMarket = this.date_diff_indays(listDate, nowStr);
                lDays = lDaysOnMarket;
            }
            if (lDays === null) {
                return Defs.LISTING_NO_VALUE;
            }
            return lDays;
        } catch (err) {
            // Logger.writeLog("ERROR:getDaysOnMarker-" + err.message);
            console.log('ERROR:getDaysOnMarket-' + err.message);
            return Defs.LISTING_NO_VALUE;
        }
    }

    public static getFormatedPrice(listPrice: any) {

        let lPrice: string = '';

        if (listPrice === null || listPrice === undefined) {
            return Defs.LISTING_NO_VALUE;
        }

        try {
            if (typeof listPrice === 'string') {
                listPrice = parseInt(listPrice, 10);
            }

            if (listPrice.toString().indexOf('$') !== -1) {
                return listPrice;
            }

            lPrice = listPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            lPrice = lPrice.substr(0, lPrice.length - 3);
        } catch (err) {
            // Logger.writeLog("ERROR:getFormatedPrice-" + err.message);
            console.log('ERROR:getFormatedPrice-' + err.message);
            return Defs.LISTING_NO_VALUE;
        }

        return '$' + lPrice;
    }

    public static getListingFromResult(featureCollection: any, sysId: number) {
        if (!featureCollection || featureCollection.features.length === 0) {
            return null;
        }

        if (featureCollection.features.length === 1 && featureCollection.features[0].properties.ml === 0) {
            return featureCollection.features[0];
        }

        for (let i = 0; i <  featureCollection.features.length; i++) {
            const feature = featureCollection.features[i];
            const featSysId = feature.properties.sid;
            if (featSysId === sysId) {
                return feature;
            }
            if (feature.properties.ml === 1) {
                const lListingProps = this.getListingFromMultiListingSearchSelection(sysId, feature);
                if (lListingProps !== null) {
                    feature.properties = lListingProps;
                    return feature;
                }
            }
        }

        return null;
    }

    public static getListingFromMultiListingSearchSelection(sysId: number, feature: any) {
        const lListings = JSON.parse(feature.properties.md);
        for (let i = 0; i < lListings.length; i++) {
            if (lListings[i].sid === sysId) {
                return lListings[i];
            }
        }
        return null;
    }

    public static addMapPostfixToImage(imageUrlInit: string) {
        if (imageUrlInit) {
            const imageUrl = imageUrlInit.replace('.jpg', '_map.jpg');
            return imageUrl;
        } else {
            return null;
        }
    }

    public static addTablePostfixToImage(imageUrlInit: string) {
        const imageUrl = imageUrlInit.replace('.jpg', '_tb.jpg');
        return imageUrl;
    }

    public static removeMapPostfixToImage(imageUrlInit: string) {
        const imageUrl = imageUrlInit.replace('_map.jpg', '.jpg');
        return imageUrl;
    }

    public static dashify(toBeDashified: string) {
        const str = toBeDashified.toLowerCase()
                .replaceAll(' ', '-')
                .replaceAll('#', '-')
                .replaceAll('`', '-')
                .replaceAll(',', '-')
                .replaceAll('/', '-')
                .replaceAll('\\', '-')
                .replaceAll('\'', '-')
                .replaceAll(':', '-')
                .replaceAll('*', '-')
                .replaceAll('?', '-')
                .replaceAll('&', 'and')
                .replaceAll('+', 'and')
                .replaceAll('.', '-')
                .replaceAll('"', '-')
                .replaceAll('!', '-')
                .replaceAll('--', '-');

        return str;
    }

    public static getListingUrl(baseURL: string, property: ListingDetail) {
        const listingTypeURL = [baseURL,
                              ListingUtil.getListingClassTypeURL(property.ClassCodeL),
                              '/',
                              ListingUtil.dashify(property.Community + ' real estate'),
                               '/',
                               null];

        const address = property.Address + ' ' + ' ' + property.ListingService + ' ' + property.MlsNo;
        listingTypeURL[5] = ListingUtil.dashify(address);

        return listingTypeURL.join('');
    }

    public static getListingClassTypeURL(classCode: number) {
        switch (classCode) {
            case 1:
                return 'residential';
            case 2:
                return 'commercial';
            case 3:
                return 'multi-family';
            case 4:
                return 'farm';
            case 5:
                return 'vacant-land';
            default:
                return 'other';
        }
    }

    public static getParcelSizeAcres(sizeInFtSq: number) {
        if (sizeInFtSq === null || sizeInFtSq === 0) {
            return Defs.LISTING_NO_VALUE;
        }

        const sizeInAcres = sizeInFtSq / 43560;

        return sizeInAcres.toFixed(1) + ' acres';

    }


    private static date_diff_indays(date1: string, date2: string) {
        const dt1 = this._getDateFromUnknownStringFormat(date1);
        const dt2 = this._getDateFromUnknownStringFormat(date2);
        if (dt1 === null || dt2 === null) {
            return null;
        }
        return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    }

    private static _getDateFromUnknownStringFormat(dateStr: string) {

        let lDate: any = null;

        // Try to parse in case epoch
        const epoch = parseInt(dateStr, 10);

        if (epoch < 946684800) { // before 2000-01-01 it was parsed incorectly so try to parse as string
            lDate = new Date(dateStr);
        } else {
            lDate = new Date(epoch);
        }

        if (isNaN(lDate)) {
            return null;
        }

        return lDate;
    }
}
